


























import { Component, Prop, Vue } from 'vue-property-decorator';
import ConversationHeader from './ConversationHeader.vue';
import { ConversationMessage } from '../../models/conversation-message';
import { default as ColourPicker } from '@/shared/services/color';

@Component({
	components: {
		ConversationHeader
	}
})
export default class ConversationPreview extends Vue {
	@Prop() public brandColour: string;
	@Prop() public outboundMessageColour: string;
	@Prop() public actionColour: string;
	@Prop() public headerText: string;
	@Prop() public typicalResponseTime: string;
	@Prop({ default: false }) public displayAvatar: boolean;
	@Prop({ default: false }) public enableAvatarTooltip: boolean;
	@Prop() public messages: ConversationMessage[];
	@Prop({ default: true }) public readonlyApps: string;

	public getContrastingSentMessageColour() {
		return ColourPicker.getContrastingColour(this.outboundMessageColour);
	}
}
